import React from "react";
import ServiceWorldCase from "@/src/components/Serviceworld/ServiceWorldCase";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

const ServiceWorldCasePage = () => {
  return (
    <LayoutProtectedRoutes>
      <ServiceWorldCase />
    </LayoutProtectedRoutes>
  );
};

export default ServiceWorldCasePage;
